(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-pleume-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sync = details => details.querySelector('summary')?.setAttribute('aria-expanded', details.getAttribute('aria-expanded') || String(details.open));
  const init = root => root.querySelectorAll('.lp-pleume-faq details').forEach(details => {
    if (details.dataset.pleumeAria) return;
    details.dataset.pleumeAria = 'true';
    sync(details);
    const observer = new MutationObserver(() => sync(details));
    observer.observe(details, { attributes: true, attributeFilter: ['aria-expanded', 'open'] });
    details.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
